let map = document.querySelector("#map")

function showMap() {
    let cords = $(".contacts-page .tab._active").data("cord")

    ymaps.ready(init);

    function init(){
        map.innerHTML = ''

        let myMap = new ymaps.Map("map", {
            center: cords,
            zoom: 16,
            controls: []
        });

        var myPlacemark = new ymaps.Placemark(cords, null, {
            preset: 'islands#redCircleDotIcon'
        });
        myMap.geoObjects.add(myPlacemark);
    }
}

if(map){
    showMap()
}



$(".contacts-page .tab").click(function () {
    $(".contacts-page .tab").removeClass("_active")
    $(this).addClass("_active")
    showMap()
    $(".contacts-page__nav .search-links__current").html($(".tab._active").html())


    console.log($(this).attr("data-tab"))
    $(".contacts-page .tab-content").removeClass("_active")
    $(`.contacts-page .tab-content.${$(this).attr("data-tab")}`).addClass("_active")
})

$(".contacts-page__nav .search-links__current").html($(".tab._active").html())

